import { getCanonicalLocales } from '@formatjs/intl-getcanonicallocales';

import { select } from '../../../index';
import type { Model, RootState, SelectorCreator, Slicer } from '../../types';

export type LocaleState = string;

const reducers = {
  set: (state: LocaleState, payload: string) => payload
};
const selectors = (slice: Slicer<LocaleState>, createSelector: SelectorCreator) => ({
  get() {
    return slice;
  },
  getIntlLocale() {
    return createSelector(
      slice,
      (rootState: RootState) => select.country.getCountry(rootState),
      (rootState: RootState) => select.account.getCountry(rootState),
      (state, geoCountry, accountCountry) => {
        const country = accountCountry || geoCountry;
        try {
          const [locale] = getCanonicalLocales(`${state}-${country}`);
          return locale;
        } catch (err) {
          return state;
        }
      }
    );
  }
});

const locale: Model<LocaleState, typeof reducers, void, void, typeof selectors> = {
  state: 'en',
  reducers,
  selectors
};

export default locale;
